<template>
  <div class="bind-qrcode-preview-wrapper">
    <!--Header-->
    <div class="qrcode-wrapper">
      <div class="title">
        <h4>SN: {{ showingDev.sn }}</h4>
        <p>{{ showingDev.clientid }}</p>
      </div>

      <div :id="`qrcode-${no}`" :class="[`qrcode-${no}`, 'qrcode']" :ref="`qrcode-${no}`"></div>

      <div class="tips">
        <div class="step">
          <i class="iconfont icon-qrcode-scan"></i>
          <p>手机扫码</p>
        </div>
        <i class="el-icon-arrow-right"></i>
        <div class="step">
          <i class="iconfont icon-write"></i>
          <p>填写信息</p>
        </div>
        <i class="el-icon-arrow-right"></i>
        <div class="step">
          <i class="iconfont icon-bind"></i>
          <p>绑定成功</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
  name: 'BindQrcodePreview',
  props: {
    title: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    showingDev: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      qrcode: {},
      no: 0
    }
  },
  watch: {
    url: function (val, oldVal) {
      setTimeout(() => {
        this.showQrcode()
      }, 100)
    }
  },
  methods: {
    // 显示二维码
    showQrcode () {
      if (JSON.stringify(this.qrcode) !== '{}') {
        this.qrcode.clear()
        this.qrcode.makeCode(this.url)
      } else {
        this.qrcode = new QRCode(`qrcode-${this.no}`, {
          width: 200,
          height: 200,
          text: this.url
        })
      }
    }
  },
  mounted () {
    this.no = Math.random() * 1000
    setTimeout(() => {
      this.showQrcode()
    }, 100)
  }
}
</script>

<style lang="scss" scoped>
.bind-qrcode-preview-wrapper {
  width: 260px;
  border-radius: 6px;
  text-align: center;
  box-shadow: 0 3px 10px 0 #ccc;
  overflow: hidden;

  .qrcode-wrapper {
    border-radius: 6px;
    background: #647594;
    color: #ffffff;

    h3 {
      padding: 0 0 .8rem;
      font-size: 20px;
      margin: 0;
    }

    .qrcode {
      width: 210px;
      height: 210px;
      margin: 0 auto;
      background: #ffffff;
      padding: .4rem;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .title {
      text-align: center;
      padding: .8rem 0;

      h4 {
        font-size: 18px;
        margin: .4rem 0;
      }
      p {
        font-size: 16px;
        margin: .4rem 0;
      }
    }

    .tips {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: .8rem 0;

      .step {
        text-align: center;
        margin: 0 .4rem;

        i {
          font-size: 24px;
        }
        p {
          margin: .3rem 0;
          font-size: 12px;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/BindQrcodePreview.vue